import { useEffect, useRef } from 'react';
import gsap from 'gsap';
import { FiArrowRight, FiShield } from 'react-icons/fi';
import { FaLeaf, FaHeart } from 'react-icons/fa';
import heroBackground from '../assets/hero-background.png';
import './Hero.css';

const benefits = [
  { title: 'Quality Ingredients', description: 'Carefully selected for everyday wellness', Icon: FaLeaf },
  { title: 'Made With Care', description: 'Thoughtful nutrition for happy pets', Icon: FaHeart },
  { title: 'Trusted Wellness', description: 'Products created with quality in mind', Icon: FiShield },
];

export default function Hero() {
  const heroRef = useRef(null);

  useEffect(() => {
    if (window.matchMedia?.('(prefers-reduced-motion: reduce)').matches) return undefined;

    const animation = gsap.context(() => {
      gsap.from('.hero__content > *', {
        y: 16,
        duration: .65,
        stagger: .09,
        ease: 'power2.out',
        clearProps: 'transform',
      });
    }, heroRef);

    return () => animation.revert();
  }, []);

  return (
    <section className="hero" ref={heroRef} aria-labelledby="hero-heading">
      <img className="hero__backdrop" src={heroBackground} alt="" aria-hidden="true" />
      <div className="hero__shade" aria-hidden="true" />
      <div className="hero__container">
        <div className="hero__content">
          <div className="hero__eyebrow">Premium Dog Wellness</div>
          <h1 id="hero-heading" className="hero__heading">
            <span>Better Nutrition.</span>{' '}
            <span>Happier Every Day.</span>
          </h1>
          <p className="hero__description">Science-backed soft chews crafted specifically for your dog's optimal health. Support their hips, gut, immune system, and coat with every single bite.</p>
          <div className="hero__actions">
            <a className="hero__button hero__button--primary" href="#dog-supplements">Explore Supplements <FiArrowRight aria-hidden="true" /></a>
            <a className="hero__button hero__button--secondary" href="#soft-chews-heading">View All Products</a>
          </div>
          <ul className="hero__benefits" aria-label="Trillium Paws benefits">
            {benefits.map(({ title, description, Icon }) => (
              <li className="hero__benefit" key={title}>
                <span className="hero__benefit-icon"><Icon aria-hidden="true" /></span>
                <span className="hero__benefit-copy"><strong>{title}</strong><span>{description}</span></span>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </section>
  );
}
